// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"fullWidthStyles_fullWidth__IOVuf"};